/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
<template>
    <div class="info-card historical-consumption-card">
        <h4>Consumo histórico</h4>
        <div class="consumption-table-wrapper">
            <div class="consumption-table-grid">
                <div class="consumption-table-row header">
                    <span>Inicio</span>
                    <span>Término</span>
                    <span class="text-right">Consumo (kWh)</span>
                    <span class="text-right">Pago a CFE</span>
                </div>

                <div class="consumption-table-row" v-for="(item, index) in consumoHistorico" :key="index">
                    <span>{{ item.inicio }}</span>
                    <span>{{ item.termino }}</span>
                    <span class="text-right">{{ (Number(item.kwh) || 0).toLocaleString() }} kWh</span>
                    <span class="text-right">{{ formatMoney(item.pago) }}</span>
                </div>

                <div class="consumption-table-row footer total-row">
                    <span></span>
                    <span class="label-total">Total Anual</span>
                    <span class="text-right">{{ computedTotalKwh.toLocaleString() }} kWh</span>
                    <span class="text-right">{{ formatMoney(computedTotalPago) }}</span>
                </div>

                <div class="consumption-table-row footer average-row">
                    <span></span>
                    <span class="label-total">Promedio Mensual</span>
                    <span class="text-right">{{ computedPromedioKwh.toLocaleString(undefined, {maximumFractionDigits: 0}) }} kWh</span>
                    <span class="text-right">{{ formatMoney(computedPromedioPago) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TablaHistorico',
    props: {
        consumoHistorico: { type: Array, required: true }
    },
    computed: {
        computedTotalKwh() {
            if (!this.consumoHistorico) return 0;
            return this.consumoHistorico.reduce((acc, item) => acc + (Number(item.kwh) || 0), 0);
        },
        computedTotalPago() {
            if (!this.consumoHistorico) return 0;
            return this.consumoHistorico.reduce((acc, item) => acc + (Number(item.pago) || 0), 0);
        },
        computedPromedioKwh() {
            if (!this.consumoHistorico || this.consumoHistorico.length === 0) return 0;
            return this.computedTotalKwh / this.consumoHistorico.length;
        },
        computedPromedioPago() {
            if (!this.consumoHistorico || this.consumoHistorico.length === 0) return 0;
            return this.computedTotalPago / this.consumoHistorico.length;
        }
    },
    methods: {
        formatMoney(val) {
            if (!val) return '$0.00';
            return val.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
        }
    }
}
</script>

<style scoped>
.info-card {
    background-color: var(--color-fondo-claro, #f8fafc);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
    margin-bottom: 25px;
}

.info-card h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 15px;
}

.consumption-table-wrapper {
    overflow-x: auto;
}

.consumption-table-grid {
    min-width: 650px;
    font-size: 14px;
    color: #4a5568;
}

.consumption-table-row {
    display: grid;
    grid-template-columns: 1.5fr 1.5fr 1fr 1fr;
    gap: 15px;
    padding: 12px 0;
    border-bottom: 1px solid #e9eef2;
}

.consumption-table-row.header {
    font-weight: 600;
    color: #718096;
}

.consumption-table-row.footer {
    padding-top: 12px;
    padding-bottom: 12px;
    color: #2d3748;
}

.consumption-table-row.footer.total-row {
    font-weight: 800;
    border-top: 2px solid #cbd5e0;
    margin-top: 10px;
    background-color: rgba(0,0,0,0.02);
}

.consumption-table-row.footer.average-row {
    font-weight: 600;
    color: #29b9f6;
    border-bottom: none;
    border-top: 1px dashed #cbd5e0;
}

.label-total {
    text-align: right;
    padding-right: 10px;
}

.text-right {
    text-align: right;
}
</style>